import React from "react";
import PlayArrowTwoToneIcon from "@mui/icons-material/PlayArrowTwoTone";
import { Button, Tooltip } from "@mui/material";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function CustomizedDialogs(props) {
  let { endDate, endTime, startDate, startTime, dependson, manage_labs, startcron, startcron1, repeat_frequency, on_days, labType } = props;

  function DateTime2(endDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endDate1 = new Date(endDate).toLocaleString("en-GB", {
      timeZone: timezone,
    });
    const endDate2 = endDate1.split(",");
    return endDate2[0].replace(/\//g, "-");
  }

  function timeDiff(
    endDate,
    endTime,
    startDate,
    startTime,
    dependson,
    manageLabs
  ) {
    const nowTime = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    
    let disable = true;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const startTime3 = new Date(`${startDate}T${startTime}:00.000Z`).toLocaleTimeString("en-GB", {
      timeZone: timezone,
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    const endTime3 = new Date(`${endDate}T${endTime}:00.000Z`).toLocaleTimeString("en-GB", {
      timeZone: timezone,
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    
    const startTimeMoment = moment(startTime3, "HH:mm");
    const endTimeMoment = moment(endTime3, "HH:mm");
    const currentTimeMoment = moment(nowTime, "HH:mm");
    const diffInMinutes = endTimeMoment.diff(currentTimeMoment, "minutes");
  
    const labEndDate = moment(endDate).format("DD-MM-YYYY");
    const currentDate = new Date().toISOString().substring(0, 10);
  
    if (diffInMinutes > 0 && diffInMinutes <= `${process.env.REACT_APP_DIFFENDTIME}`) {
      disable = true;
      return disable;
    }
    if (dependson === "immediate" || dependson === "always") {
      if (DateTime2(currentDate) == labEndDate) {
        if (
          diffInMinutes > 0 &&
          diffInMinutes <= `${process.env.REACT_APP_DIFFENDTIME}`
        ) {
          disable = true;
        } else if (diffInMinutes <= 0) {
          disable = true;
        } else {
          disable = false;
        }
      } else {
        if (new Date(currentDate) <= new Date(endDate)) {
          disable = false;
        } else {
          disable = true;
        }
      }
    } else if (dependson === "during_training") {
      if (manageLabs === "no") {
        if (repeat_frequency.toLowerCase() === "day") {

          const day = Number(currentDate.split("-")[2].trim());  // "17"
          const month = currentDate.split("-")[1];  // "06"

          const cronParts_1 = startcron.split(" ");
          const dayOfMonth_1 = cronParts_1[2];
          const daysArray_1 = dayOfMonth_1.split(',').map(Number);  // [28, 29, 30]
          const startcron_month_1 = cronParts_1[3];  // "4"

          const cronParts_2 = startcron1.split(" ");
          const dayOfMonth_2 = cronParts_2[2];
          const daysArray_2 = dayOfMonth_2.split(',').map(Number);  // [28, 29, 30]
          const startcron_month_2 = cronParts_2[3];  // "4"

          const paddedMonth_1 = String(startcron_month_1).padStart(2, '0');
          const paddedMonth_2 = String(startcron_month_2).padStart(2, '0');

          if (month === paddedMonth_1){
            if (daysArray_1.includes(day)) {
              disable = false;
            }
            else{
              disable = true;
              return disable;
            }
          }
          else if(month === paddedMonth_2){
            if (daysArray_2.includes(day)) {
              disable = false;
            }
            else{
              disable = true;
              return disable;
            }
          }
        }
        else{ // verify if week 
          const day_split = on_days.split(',')
          
          const today = new Date();
          const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
          const currentDay = days[today.getDay()];

          if (day_split.includes(currentDay)) {
            disable = false;
          }
          else{
            disable = true;
            return disable;
          }
        }

        const isBetween = currentTimeMoment.isBetween(startTimeMoment, endTimeMoment, null, '[]'); // '[]' includes boundaries
        if (isBetween) {
          disable = false;
        } else {
          disable = true;
        }
      }
      else { // manageLabs = "yes"
        disable = false;
      }
    }
    return disable;
  }
  

  const [open, setOpen] = React.useState(false);
  const [popupopen, setPopUpOpen] = React.useState(false);
  const [opentitle, setOpentitle] = React.useState();
  const [popupopentitle, setPopupOpentitle] = React.useState("Are you sure you want to start a lab?.");

  const handleClose = () => {
    setOpen(false);
    setPopUpOpen(false);
  };

  const handlePopUpClose = () => {
    setPopUpOpen(false);
  };

  const handleOpen = () => {
    setPopUpOpen(true);
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    let api_call = ""
    const InstanceID = localStorage.getItem("InstanceID");
    if (labType === "preconfig" || labType === "pc") {
      api_call = `${process.env.REACT_APP_API_URL}/api/startpreconfiguredlab/${InstanceID}`
    }
    else if (labType === "custom") {
      api_call = `${process.env.REACT_APP_API_URL}/api/startlab/${InstanceID}`
    }
    else if (labType === "hvm") {
      api_call = `${process.env.REACT_APP_API_URL}/api/starthvmclab/${InstanceID}`
    }
    else if (labType === "wise") {
      api_call = `${process.env.REACT_APP_API_URL}/api/startwiselab/${InstanceID}`
    }
    else if (labType === "cloud") {
      api_call = `${process.env.REACT_APP_API_URL}/api/startcloudlab/${InstanceID}`
    }
    else if (labType === "svm") {
      api_call = `${process.env.REACT_APP_API_URL}/api/startsvmlab/${InstanceID}`
    }
    else if (labType === "manual") {
      api_call = `${process.env.REACT_APP_API_URL}/api/manualstartlab/${InstanceID}`
    }
    
    fetch(api_call, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          if (data === "Success") {
            setOpen(false);
            window.location.reload();
          }
          else {
            setOpen(true);
            setOpentitle(data);
          }
        } else if (data && data.name) {
          setOpen(true);
          setOpentitle(data.name[0]);
        }
      })
      .catch((error) => {
        setOpen(false);
        window.location.reload();
      });
  };

  return (
    <div>
      <Dialog
        open={popupopen}
        onClose={handlePopUpClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {popupopentitle} {" "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"></DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handlePopUpClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmitClick} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {opentitle} {" "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"></DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Tooltip
        title={
          timeDiff(endDate, endTime, startDate, startTime, dependson, manage_labs)
            ? "You can't start this lab yet"
            : "Start"
        }
        arrow
      >
        <span> {/* Wrapping span allows tooltip even when button is disabled */}
          <Button
            sx={{
              mx: 0.5,
              height: { xs: "26px", sm: "30px" },
              width: { xs: "26px", sm: "30px" },
              minWidth: "auto",
              marginBottom: { xs: "3px", sm: "5px" },
              marginTop: { xs: "-18px", sm: "-20px" },
              borderRadius: "50px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
              p: 0,
            }}
            variant="contained"
            color="primary"
            onClick={handleOpen}
            disabled={timeDiff(endDate, endTime, startDate, startTime, dependson, manage_labs)}
            aria-label="start"
          >
            <PlayArrowTwoToneIcon sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }} />
          </Button>
        </span>
      </Tooltip>
    </div>
  );
  
}
